import { darken } from 'polished'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { theme } from '../builderUtils/theme'

export const CTALink = styled(Link)`
  color: ${(props) => (!props.ctaVariant ? theme.white : theme.coral)};
  text-decoration: none;
`

export const CTAButtonContainer = styled.div`
  background-color: ${(props) => (!props.ctaVariant ? theme.coral : theme.cream)};
  color: ${(props) => (!props.ctaVariant ? theme.cream : theme.coral)};
  font-size: 1.25rem; /* text-xl */
  font-weight: 500; /* font-medium */
  text-align: center;
  padding: 1.25rem 2rem; /* py-5 px-8 */
  border-radius: 35.438px;
  overflow: hidden;
  border: ${(props) => (props.ctaVariant ? `2px solid ${theme.coral}` : 'none')};
  width: 217.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s;

  &:hover {
    background-color: ${(props) =>
      !props.ctaVariant ? darken(0.1, theme.coral) : darken(0.03, theme.cream)};
    color: ${(props) => (!props.ctaVariant ? theme.cream : darken(0.1, theme.coral))};
    border: ${(props) => (props.ctaVariant ? `2px solid ${darken(0.1, theme.coral)}` : 'none')};
    cursor: pointer;
  }

  @media (max-width: 768px) {
    width: min(303px, 90vw);
    height: 48px;
    padding: 0.75rem 1.25rem;
  }
`
